import React from "react"
import { Trans } from "@lingui/macro";

export const getMeterName = (member) => {
  const id = member.nameId || 0
  const address = member.address || {}
  const addressString = `- ${address.street_address || ''}`.trim()
  if (member.meter) {
    if (member.service_provider === 'agency_meter') {
      return <Trans>Agency {addressString}</Trans>
    }
    return <Trans>Meter {id}</Trans>
  }
  if (member.service_provider === 'csa') {
    if (member.csa) {
      return <Trans>{member.csa.company_name}</Trans>
    } else {
      return <Trans>CSA</Trans>
    }
  }
  return <Trans>Consolidated</Trans>
}

export const isConsolidatedMember = member => 
   !member.meter && member.balance?.isPrimaryAccount

export const isBatteryCustomer = member =>
  member?.balance?.billing_segment.includes('battery')
